import { render, staticRenderFns } from "./HistoricalPatternTypesSelect.vue?vue&type=template&id=531b71a2&scoped=true&lang=pug"
import script from "./HistoricalPatternTypesSelect.vue?vue&type=script&lang=js"
export * from "./HistoricalPatternTypesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531b71a2",
  null
  
)

export default component.exports